<template>
  <page-section
    :section-name="name"
    :content="textContent"
    wrapper-class="bg-white py-6"
  >
    <template #header="{ content }">
      <div class="container mx-auto p-6 flex">
        <h2 v-html="content.title" class="text-green lowercase text-center" />
      </div>
    </template>
    <template v-slot="{ content }">
      <div class="timeline font-sans">
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[0]" role="presentation" />
            <p v-html="content.body[0]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              40
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[1]" role="presentation" />
            <p v-html="content.body[1]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              30
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[2]" role="presentation" />
            <p v-html="content.body[2]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              20
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[3]" role="presentation" />
            <p v-html="content.body[3]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              20
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[4]" role="presentation" />
            <p v-html="content.body[4]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              20
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[5]" role="presentation" />
            <p v-html="content.body[5]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              15
            </span>
          </div>
        </fade-shift>
        <fade-shift ratio="0.25" class="row">
          <div class="text">
            <img :src="images[6]" role="presentation" />
            <p v-html="content.body[6]" />
          </div>
          <div class="year" aria-hidden="true">
            <div class="images">
              <img
                class="outline"
                role="presentation"
                src="../assets/images/dotted_circle.svg"
              />
              <img
                class="circle"
                role="presentation"
                src="../assets/images/water_colour_circle.png"
              />
            </div>
            <span class="number text-shadow">
              15
            </span>
          </div>
        </fade-shift>
      </div>
    </template>
  </page-section>
</template>

<script>
export default {
  name: "MarkingMilestones",
  components: {
    pageSection: () => import("@/components/PageSection.vue"),
    fadeShift: () => import("@/components/FadeShift.vue"),
  },
  data() {
    return {
      name: "markingMilestones",
      images: [
        require("../assets/images/Photos/Marking_milestones/chc_anniversary_2.jpg"),
        require("../assets/images/Photos/Marking_milestones/mtc_anniversary_credit_mae_tao_clinic.jpg"),
        require("../assets/images/Photos/Marking_milestones/backpack_health_credit_backpack_health_workers_team.jpg"),
        require("../assets/images/Photos/Marking_milestones/mobile_biodiversity_festival_credit_deccan_development_society_2.jpg"),
        require("../assets/images/Photos/Marking_milestones/mining_watch.jpg"),
        require("../assets/images/Photos/Marking_milestones/copagen.jpg"),
        require("../assets/images/Photos/Marking_milestones/colombiadiversa.jpg"),
      ],
    };
  },
  computed: {
    textContent() {
      const { name } = this;

      return this.$t(`i18nSections.${name}`);
    },
  },
};
</script>

<style lang="scss">
.timeline > .row {
  display: grid;
  grid-template-areas: "image text";
  grid-template-columns: 1fr 3fr;
  grid-template-rows: 1fr;
  gap: 2rem;

  &:not(:first-of-type) {
    .year::before {
      content: " ";
      display: flex;
      position: absolute;
      bottom: 75%;
      justify-content: center;
      width: 2px;
      height: 4rem;
      background-image: url("../assets/images/dotted_line-long.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-origin: content-box;
      background-size: 100%;
    }
  }

  @screen lg {
    grid-template-areas: "text image .";
    grid-template-columns: 2fr 1fr 2fr;

    &:nth-child(even) {
      grid-template-areas: ". image text";

      .images::after {
        right: -2.25rem;
        width: 6px;
        height: 4rem;
        transform: rotate(-90deg);
      }
    }

    &:nth-child(odd) {
      .images::before {
        left: -2.25rem;
        width: 6px;
        height: 4rem;
        transform: rotate(90deg);
      }
    }
  }

  .text {
    display: grid;
    grid-area: text;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
    gap: 1rem;
    align-items: center;

    img {
      display: none;
    }

    @screen md {
      grid-template-columns: 1fr 3fr;

      img {
        display: block;
      }
    }
  }

  .year {
    @apply py-10;

    display: flex;
    position: relative;
    grid-area: image;
    align-items: center;
    justify-content: center;
  }

  .images {
    position: relative;

    > img {
      width: 4rem;
    }

    .circle {
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
    }

    &::before,
    &::after {
      content: " ";
      display: flex;
      position: absolute;
      top: 0;
      bottom: 0;
      align-items: center;
      background-image: url("../assets/images/dotted_line-short.svg");
      background-repeat: no-repeat;
      background-position: center;
      background-origin: content-box;
      background-size: 100%;
    }
  }

  .number {
    @apply text-5xl text-white;

    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    align-items: center;
    justify-content: center;
    margin-top: -0.75rem;
    font-weight: bold;
  }
}
</style>
